/* ============================================================
   INSTA SLIM HEALTH STORE — Theme JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* Sticky header scroll class
  ============================================================ */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mobile drawer
  ============================================================ */
  const hamburger    = document.querySelector('.hamburger');
  const mobileDrawer = document.querySelector('.mobile-drawer');
  const drawerOverlay = document.querySelector('.drawer-overlay');
  const drawerClose  = document.querySelector('.mobile-drawer__close');

  const openDrawer = () => {
    mobileDrawer?.classList.add('open');
    drawerOverlay?.classList.add('active');
    hamburger?.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  const closeDrawer = () => {
    mobileDrawer?.classList.remove('open');
    drawerOverlay?.classList.remove('active');
    hamburger?.classList.remove('open');
    document.body.style.overflow = '';
  };

  hamburger?.addEventListener('click', openDrawer);
  drawerClose?.addEventListener('click', closeDrawer);
  drawerOverlay?.addEventListener('click', closeDrawer);

  /* Scroll-in animations
  ============================================================ */
  const fadeEls = document.querySelectorAll('.fade-up');
  if ('IntersectionObserver' in window && fadeEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    fadeEls.forEach(el => io.observe(el));
  } else {
    fadeEls.forEach(el => el.classList.add('visible'));
  }

  /* Product quantity selector
  ============================================================ */
  document.querySelectorAll('.qty-selector').forEach(selector => {
    const input = selector.querySelector('.qty-input');
    selector.querySelector('.qty-btn--minus')?.addEventListener('click', () => {
      const v = parseInt(input.value, 10);
      if (v > 1) input.value = v - 1;
    });
    selector.querySelector('.qty-btn--plus')?.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  /* Product image gallery (main + thumbs)
  ============================================================ */
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.src = thumb.dataset.full || thumb.querySelector('img')?.src;
      }
    });
  });

  /* Variant selector
  ============================================================ */
  document.querySelectorAll('.product-variants__options').forEach(group => {
    group.querySelectorAll('.variant-btn:not(.sold-out)').forEach(btn => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
      });
    });
  });

  /* Wishlist toggle
  ============================================================ */
  document.querySelectorAll('.product-card__wishlist').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const svg = btn.querySelector('svg');
      const isActive = btn.classList.toggle('wishlisted');
      if (svg) {
        svg.style.fill = isActive ? 'currentColor' : 'none';
        btn.style.color = isActive ? 'var(--green)' : '';
        btn.style.borderColor = isActive ? 'var(--green)' : '';
      }
    });
  });

  /* Newsletter form
  ============================================================ */
  const nlForm = document.querySelector('.newsletter__form');
  nlForm?.addEventListener('submit', e => {
    e.preventDefault();
    const input = nlForm.querySelector('.newsletter__input');
    if (!input?.value.trim()) return;
    const disclaimer = document.querySelector('.newsletter__disclaimer');
    if (disclaimer) {
      disclaimer.textContent = 'Thank you for subscribing!';
      disclaimer.style.color = 'var(--green)';
    }
    input.value = '';
  });

  /* Cart item remove
  ============================================================ */
  document.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.cart-item');
      item?.remove();
    });
  });

  /* Add to cart button feedback
  ============================================================ */
  document.querySelectorAll('.product-card__atc, .btn--atc').forEach(btn => {
    btn.addEventListener('click', function () {
      const original = this.textContent;
      this.textContent = 'Added!';
      this.style.background = 'var(--green-dark)';
      setTimeout(() => {
        this.textContent = original;
        this.style.background = '';
      }, 1500);
    });
  });

});
